module.exports = __webpack_public_path__ + "img/COD.3b68a6a6.png";